module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/timeclock/geofencing-00f76c.png";